export default "__VITE_ASSET__Di$fUx5u__"